import Route from '@ember/routing/route';
import { instrumentRoutePerformance } from '@sentry/ember';
import connectors from 'scaleflow/utils/connectors-config';

class ConnectorsIndexRoute extends Route {
  model() {
    return {
      // Manual upload is listed alongside the real integrations. It has no
      // "Connect"/OAuth flow, but it now has a detail page of its own
      // (`connectors.manual`) where archives are uploaded and managed, which is
      // what previously justified hiding it. See
      // docs/ai-blueprints/manual-upload-archive-library.md.
      connectors,
      integrations: this.modelFor('connectors'),
    };
  }
}

export default instrumentRoutePerformance(ConnectorsIndexRoute);
